import { useEffect, useState } from "react";
import { UserButton } from "@clerk/clerk-react";
import { studentService } from "../../services/studentService";

// Module-level cache for the school logo so we fetch it once per session
// rather than on every page's Header mount. `undefined` = not fetched yet,
// `null` = fetched, no logo, string = the logo URL.
let logoCache;

/**
 * Prime/refresh the cached school logo. Called by the Settings page after an
 * upload/remove so the header reflects the change on the next render without
 * a full reload.
 */
export function primeSchoolLogo(url) {
  logoCache = url || null;
}

const TopHeader = ({ schoolName }) => {
  const [schoolLogo, setSchoolLogo] = useState(logoCache ?? null);

  useEffect(() => {
    if (logoCache !== undefined) {
      setSchoolLogo(logoCache);
      return;
    }
    let cancelled = false;
    studentService
      .getSchoolSettings()
      .then((s) => {
        logoCache = s.logoUrl || null;
        if (!cancelled) setSchoolLogo(logoCache);
      })
      .catch(() => {
        // Non-fatal — header just renders without the school logo.
        logoCache = null;
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="bg-white shadow-sm flex justify-between items-center gap-[10px] py-4 px-8">
      <div className="min-h-[36px] flex items-center gap-3">
        {schoolLogo ? (
          <img
            src={schoolLogo}
            alt={schoolName ? `${schoolName} logo` : "School logo"}
            className="h-9 w-9 rounded-md object-contain border border-gray-100 bg-white flex-shrink-0"
          />
        ) : null}
        {schoolName ? <h1 className="text-gray-900 text-lg font-semibold leading-tight">{schoolName}</h1> : null}
      </div>

      <UserButton
        afterSignOutUrl="/signin"
        appearance={{ elements: { avatarBox: "h-9 w-9" } }}
      />
    </div>
  );
};

export default TopHeader;
